import { render, staticRenderFns } from "./detail_industry.vue?vue&type=template&id=7df515cb&scoped=true"
import script from "./detail_industry.vue?vue&type=script&lang=js"
export * from "./detail_industry.vue?vue&type=script&lang=js"
import style0 from "./detail_industry.vue?vue&type=style&index=0&id=7df515cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df515cb",
  null
  
)

export default component.exports